import React from "react";
import InteractionIntervalSetting from "../../../../../models/communications/InteractionIntervalSetting";
import CodeIcon from "@mui/icons-material/Code";
import useConditions from "../../../../../hooks/useConditions";
import { useStoreSelector } from "../../../../../store/Hooks";
import { IconButton } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import Button from "@mui/material/Button";

interface IntervalSetSaveButtonProps {
    handler?: any;
    overallPosition?: string;
    scrollPosition?: number;
}

const IntervalSetSaveButton = (
    props: IntervalSetSaveButtonProps,
) => {


    let style:any = {}
    if(props.overallPosition=="top"){
       style =  { position: 'absolute', right: 30,  top:80,  zIndex: 10, height:"40px" }
    } else {
        style =  { position: 'absolute', right:  30,   bottom:35, zIndex: 10, height:"40px" }

    }
    return (
        <Button onClick={() => {
            if(props.handler){
                props.handler()
            }
        }}
        style={style}
            variant="contained"
            color="success" >
            <SaveIcon />
            Save
        </Button>

    );
};

export default IntervalSetSaveButton;
